<ng-container *rxLet="state$ as state">
  <section class="notifications-section" data-test-id="user-profile-notifications-container" id="notifications">
    <h4 class="font-bold">myDarize Notifications</h4>
    @if (!state.notificationSettingsLoading) {
      @if (state.notificationSettings && notificationsForm) {
        <p>
          These are email notifications to remind you about updates within the Darize community you may have missed in myDarize.
          You may change this setting at any time by turning off this option.
        </p>
        <div class="sliders-container">
          <form [formGroup]="notificationsForm">
            <mat-slide-toggle
              class="slider"
              color="accent"
              data-test-id="user-profile-notifications-slider"
              disableRipple="true"
              formControlName="subscription"
            >
              I want to receive Darize email notifications about updates in myDarize.
            </mat-slide-toggle>
          </form>
        </div>
        @if (notificationsForm?.controls['subscription']?.value) {
          <div class="frequency-section">
            <label class="standalone-label">Where you receive notifications</label>
            <p>{{ state.notificationSettings?.Email }}</p>
          </div>
          <notification-frequency
            [canEdit]="state.canEdit"
            [frequency]="state.notificationSettings.SummaryNotificationFrequency"
            [saving]="state.notificationSettingsSaving"
            (frequencyUpdated)="notificationSettingsFrequencyUpdated($event)"
            data-test-id="user-profile-notificationsFrequency-container"
          ></notification-frequency>
        }
      } @else {
        <no-data></no-data>
      }
    } @else {
      <div class="flex flex-center-start w-full h-full">
        <loader color="primary"></loader>
      </div>
    }
  </section>
</ng-container>
